"use client";

import Image from "next/image";
import "./StatsOverview.scss";
import Button from "@/components/Button/Button";
import DashboardMetricsImage from "@/assets/images/products/serviceconnect/ServicePerformanceMetrics.png";
import Link from "next/link";

const StatsOverview = () => {
  return (
    <section className="dashboard-metrics-section">
      <div className="container">
        <div className="row align-items-center">

          {/* Image Section */}
          <div className="col-12 col-md-6 image-container" data-aos="zoom-in">
            <Image
              src={DashboardMetricsImage}
              alt="worktrack attendance"
              className="img-fluid"
              width={700}
              height={500}
            />
          </div>

          {/* Text Section */}
          <div className="col-12 col-md-6">
            <h2>What is Service Connect?</h2>

            <p>
              Service Connect is an advanced service management software by GSUS
              Star Softwares, designed to streamline field service operations,
              automate workflows, and deliver exceptional customer experiences.
              Whether you're handling AMC, installation, repair, or maintenance—
              Service Connect brings all your service data into one centralized system.
            </p>

            <Link href="/about" aria-label="Learn more about Service Connect">
              <Button variant="primary" size="lg">
                Learn More
              </Button>
            </Link>

          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsOverview;
